import React from 'react';

const WIDTH = 1080;
const HEIGHT = 1350;

function shadeColor(hex, amount) {
  const cleaned = hex.replace('#', '');
  if (cleaned.length !== 6) return hex;
  const num = parseInt(cleaned, 16);
  const r = Math.max(0, Math.min(255, (num >> 16) + amount));
  const g = Math.max(0, Math.min(255, ((num >> 8) & 0xff) + amount));
  const b = Math.max(0, Math.min(255, (num & 0xff) + amount));
  return `rgb(${r},${g},${b})`;
}

function BatterSVG() {
  return (
    <svg
      viewBox="0 0 160 280"
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: 310, height: 520 }}
    >
      <circle cx="105" cy="28" r="26" fill="white" />
      <ellipse cx="91" cy="46" rx="20" ry="9" fill="white" />
      <path d="M88,54 Q96,92 93,132 L110,132 Q114,92 120,54 Z" fill="white" />
      <path
        d="M116,72 Q138,60 154,46 Q158,42 160,38"
        stroke="white"
        strokeWidth="13"
        fill="none"
        strokeLinecap="round"
      />
      <line x1="152" y1="46" x2="118" y2="136" stroke="white" strokeWidth="9" strokeLinecap="round" />
      <path
        d="M88,80 Q70,92 60,108"
        stroke="white"
        strokeWidth="11"
        fill="none"
        strokeLinecap="round"
      />
      <path
        d="M93,132 Q84,182 76,234 Q73,248 71,262"
        stroke="white"
        strokeWidth="15"
        fill="none"
        strokeLinecap="round"
      />
      <path
        d="M108,132 Q120,182 128,234 Q131,248 133,262"
        stroke="white"
        strokeWidth="15"
        fill="none"
        strokeLinecap="round"
      />
    </svg>
  );
}

function PitcherSVG() {
  return (
    <svg
      viewBox="0 0 160 280"
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: 310, height: 520 }}
    >
      <circle cx="80" cy="28" r="26" fill="white" />
      <path d="M66,54 Q73,92 70,132 L88,132 Q93,92 95,54 Z" fill="white" />
      <path
        d="M93,70 Q114,48 132,28 Q137,22 140,16"
        stroke="white"
        strokeWidth="13"
        fill="none"
        strokeLinecap="round"
      />
      <path
        d="M67,80 Q46,96 32,114"
        stroke="white"
        strokeWidth="12"
        fill="none"
        strokeLinecap="round"
      />
      <path
        d="M72,132 Q57,182 43,228 Q38,244 34,262"
        stroke="white"
        strokeWidth="15"
        fill="none"
        strokeLinecap="round"
      />
      <path
        d="M86,132 Q98,182 108,228 Q112,244 114,262"
        stroke="white"
        strokeWidth="15"
        fill="none"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default function BragCardPreview({
  id = 'brag-card-preview',
  playerName = 'PLAYER NAME',
  statLine = '',
  milestoneLabel = '',
  milestoneEmoji,        // accepted but not rendered — emoji breaks html2canvas
  milestoneType = 'multihit',
  primaryColor = '#1a1e2e',
  accentColor = '#e8c84a',
  playerPhoto = null,
  backgroundImage = null,
  subscriptionPlan = null,
  playerPhotoContainerRef = null,
  isPexelsBackground = false,
  templateStyle = 'classic',
  playerPhotoX = 50,
  gameContext = '',
  playerPhotoY = 50,
  playerPhotoScale = 100,
}) {
  const isPitcher = milestoneType === 'strikeouts';

  // Player Card only: split statLine on middle-dot separator into individual lines
  const statParts =
    templateStyle === 'player-card' && statLine
      ? statLine.split(/\s*[·•|]\s*/).filter(Boolean)
      : [];

  return (
    <div
      id={id}
      style={{
        width: WIDTH,
        height: HEIGHT,
        position: 'relative',
        overflow: 'hidden',
        background: `linear-gradient(155deg, ${primaryColor} 0%, ${shadeColor(primaryColor, -35)} 100%)`,
        fontFamily: "'Bebas Neue', 'Arial Narrow', Arial, sans-serif",
      }}
    >
      {templateStyle === 'player-card' ? (

        /* ─── PLAYER CARD TEMPLATE ──────────────────────────────────── */
        <>
          {/* ── Card background override (#1a1a1a) ────────────────── */}
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: WIDTH,
              height: HEIGHT,
              background: '#1a1a1a',
              zIndex: 0,
            }}
          />

          {/* ── Background image — full bleed (behind all content) ── */}
          {backgroundImage && (
            <>
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: WIDTH,
                  height: HEIGHT,
                  overflow: 'hidden',
                  zIndex: 1,
                }}
              >
                <img
                  src={backgroundImage}
                  alt=""
                  crossOrigin="anonymous"
                  style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 'auto',
                    height: HEIGHT,
                    minWidth: WIDTH,
                  }}
                />
              </div>
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: WIDTH,
                  height: HEIGHT,
                  background:
                    'linear-gradient(to bottom, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0.2) 40%, rgba(0,0,0,0.75) 100%)',
                  zIndex: 2,
                }}
              />
            </>
          )}

          {/* ── Name banner ───────────────────────────────────────── */}
          {/* Container: navy bg, 32px side margins, drop shadow      */}
          <div
            style={{
              position: 'absolute',
              top: 40,
              left: 32,
              width: 1016,
              height: 152,
              background: '#1a237e',
              boxShadow: '0 6px 12px rgba(0,0,0,0.4)',
              zIndex: 3,
              overflow: 'hidden',
            }}
          >
            {/* Top highlight line */}
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: 1016,
                height: 4,
                background: '#3949ab',
              }}
            />
            {/* Bottom shadow line */}
            <div
              style={{
                position: 'absolute',
                bottom: 0,
                left: 0,
                width: 1016,
                height: 4,
                background: '#0d1340',
              }}
            />
            {/* Left crimson stripe */}
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: 10,
                height: 152,
                background: '#c62828',
              }}
            />
            {/* Player name — vertically centered: (152-104)/2 = 24px */}
            <div
              style={{
                position: 'absolute',
                top: 24,
                left: 0,
                width: 1016,
                fontFamily: "'Bebas Neue', 'Arial Narrow', Arial, sans-serif",
                fontSize: 104,
                lineHeight: 1,
                color: '#ffffff',
                letterSpacing: 4,
                textAlign: 'center',
              }}
            >
              {playerName || 'PLAYER NAME'}
            </div>
          </div>

          {/* ── Player photo section ───────────────────────────────── */}
          {/* 4:3 crop locked — container is 1016×580 with 4px border */}
          {/* 24px gap below name banner (banner bottom = 40+152=192, photo top = 216) */}
          {playerPhoto ? (
            <div
              className="brag-card-pc-photo-container"
              style={{
                position: 'absolute',
                top: 216,
                left: 32,
                width: 1016,
                height: 580,
                overflow: 'hidden',
                border: '4px solid #cccccc',
                boxSizing: 'border-box',
                boxShadow: '0 8px 16px rgba(0,0,0,0.5)',
                zIndex: 4,
              }}
            >
              {/* Inner content is 1008×572 after 4px border each side */}
              <img
                src={playerPhoto}
                alt=""
                style={{
                  position: 'absolute',
                  top: `${playerPhotoY}%`,
                  left: `${playerPhotoX}%`,
                  transform: `translate(-50%, -50%) scale(${playerPhotoScale / 100})`,
                  transformOrigin: `center center`,
                  display: 'block',
                  width: 'auto',
                  height: 'auto',
                  maxWidth: 1008,
                  minWidth: 1008,
                  minHeight: 572,
                }}
              />
            </div>
          ) : (
            /* Silhouette fallback — centered in photo zone */
            <div
              style={{
                position: 'absolute',
                top: 246,
                left: Math.round((WIDTH - 310) / 2),
                width: 310,
                height: 520,
                zIndex: 4,
                opacity: 0.13,
                pointerEvents: 'none',
              }}
            >
              {isPitcher ? <PitcherSVG /> : <BatterSVG />}
            </div>
          )}

          {/* ── Stats section ──────────────────────────────────────── */}
          {/* Starts just below photo (top:796), padded 32px each end  */}
          <div
            style={{
              position: 'absolute',
              top: 796,
              left: 32,
              width: 1016,
              paddingTop: 32,
              paddingBottom: 32,
              zIndex: 5,
            }}
          >
            {/* Milestone label — gold 3D block, larger than stat blocks */}
            {milestoneLabel && (
              <div style={{ textAlign: 'center', marginBottom: 32 }}>
                <div
                  style={{
                    display: 'inline-block',
                    background: '#c9a227',
                    boxShadow: '10px 10px 0px #5a3a00',
                    padding: '20px 40px',
                    borderRadius: 6,
                    fontFamily: "'Bebas Neue', 'Arial Narrow', Arial, sans-serif",
                    fontSize: 64,
                    color: '#1a1a1a',
                    letterSpacing: 2,
                  }}
                >
                  {milestoneLabel}
                </div>
              </div>
            )}

            {/* Stat blocks — 2x2 grid for 3+ stats, stacked for 1-2 */}
            {statParts.length > 0 ? (
              statParts.length >= 3 ? (
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr',
                  gap: 12,
                  width: '100%',
                  padding: '0 16px',
                  boxSizing: 'border-box',
                }}>
                  {statParts.map((part, i) => (
                    <div
                      key={i}
                      style={{
                        textAlign: 'center',
                        background: '#2a4a8e',
                        boxShadow: '6px 6px 0px #5a4a1a',
                        padding: '12px 16px',
                        borderRadius: 6,
                        fontFamily: "'Bebas Neue', 'Arial Narrow', Arial, sans-serif",
                        fontSize: 44,
                        color: '#ffffff',
                        letterSpacing: 2,
                      }}
                    >
                      {part}
                    </div>
                  ))}
                </div>
              ) : (
                statParts.map((part, i) => (
                  <div
                    key={i}
                    style={{
                      textAlign: 'center',
                      marginBottom: i < statParts.length - 1 ? 16 : 0,
                    }}
                  >
                    <div
                      style={{
                        display: 'inline-block',
                        background: '#2a4a8e',
                        boxShadow: '10px 10px 0px #5a4a1a',
                        padding: '16px 32px',
                        borderRadius: 6,
                        fontFamily: "'Bebas Neue', 'Arial Narrow', Arial, sans-serif",
                        fontSize: 56,
                        color: '#ffffff',
                        letterSpacing: 2,
                      }}
                    >
                      {part}
                    </div>
                  </div>
                ))
              )
            ) : (
              <div style={{ textAlign: 'center' }}>
                <div
                  style={{
                    display: 'inline-block',
                    background: '#2a4a8e',
                    boxShadow: '10px 10px 0px #5a4a1a',
                    padding: '16px 32px',
                    borderRadius: 6,
                    fontFamily:
                      "'Bebas Neue', 'Arial Narrow', Arial, sans-serif",
                    fontSize: 56,
                    color: 'rgba(255,255,255,0.25)',
                    letterSpacing: 2,
                  }}
                >
                  STAT LINE
                </div>
              </div>
            )}
            {gameContext ? (
              <div style={{
                textAlign: 'center',
                marginTop: 16,
                fontSize: 36,
                fontFamily: "'Bebas Neue', 'Arial Narrow', Arial, sans-serif",
                color: 'rgba(255,255,255,0.7)',
                letterSpacing: 2,
              }}>
                {gameContext}
              </div>
            ) : null}
          </div>

          {/* ── Corner accents — top left (3 layers, 22deg) ───────── */}
          {/* All at z:2 — DOM order (red→gold→navy) handles layering  */}
          {/* Layer 1: deep red (back) */}
          <div
            style={{
              position: 'absolute',
              top: -50,
              left: -60,
              width: 160,
              height: 80,
              background: '#8b1a1a',
              transform: 'rotate(22deg)',
              boxShadow: '4px 4px 8px rgba(0,0,0,0.5)',
              zIndex: 2,
            }}
          />
          {/* Layer 2: gold */}
          <div
            style={{
              position: 'absolute',
              top: -34,
              left: -44,
              width: 160,
              height: 80,
              background: '#c9a227',
              transform: 'rotate(22deg)',
              boxShadow: '4px 4px 8px rgba(0,0,0,0.5)',
              zIndex: 2,
            }}
          />
          {/* Layer 3: deep navy (front) */}
          <div
            style={{
              position: 'absolute',
              top: -18,
              left: -28,
              width: 160,
              height: 80,
              background: '#1a237e',
              transform: 'rotate(22deg)',
              boxShadow: '4px 4px 8px rgba(0,0,0,0.5)',
              zIndex: 2,
            }}
          />

          {/* ── Corner accents — bottom right (3 layers, 22deg) ───── */}
          {/* Layer 1: deep red (back) */}
          <div
            style={{
              position: 'absolute',
              top: 1320,
              left: 980,
              width: 160,
              height: 80,
              background: '#8b1a1a',
              transform: 'rotate(22deg)',
              boxShadow: '4px 4px 8px rgba(0,0,0,0.5)',
              zIndex: 2,
            }}
          />
          {/* Layer 2: gold */}
          <div
            style={{
              position: 'absolute',
              top: 1304,
              left: 964,
              width: 160,
              height: 80,
              background: '#c9a227',
              transform: 'rotate(22deg)',
              boxShadow: '4px 4px 8px rgba(0,0,0,0.5)',
              zIndex: 2,
            }}
          />
          {/* Layer 3: deep navy (front) */}
          <div
            style={{
              position: 'absolute',
              top: 1288,
              left: 948,
              width: 160,
              height: 80,
              background: '#1a237e',
              transform: 'rotate(22deg)',
              boxShadow: '4px 4px 8px rgba(0,0,0,0.5)',
              zIndex: 2,
            }}
          />
        </>

      ) : (

        /* ─── CLASSIC TEMPLATE (unchanged) ─────────────────────────── */
        <>
          {/* ── Background image ─────────────────────────────── */}
          {backgroundImage && (
            <>
              {/* Wrapper with overflow:hidden clips the img to card bounds.
                  objectFit/objectPosition are inline — html2canvas reads computed styles. */}
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: WIDTH,
                  height: HEIGHT,
                  overflow: 'hidden',
                  zIndex: 1,
                }}
              >
                <img
                  src={backgroundImage}
                  alt=""
                  crossOrigin="anonymous"
                  style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 'auto',
                    height: HEIGHT,
                    minWidth: WIDTH,
                  }}
                />
              </div>
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: WIDTH,
                  height: HEIGHT,
                  background:
                    'linear-gradient(to bottom, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0.2) 45%, rgba(0,0,0,0.82) 100%)',
                  zIndex: 2,
                }}
              />
            </>
          )}

          {/* ── Corner accent — top left ──────────────────────── */}
          {/* Two solid rectangles rotated ~15 deg, partially off-screen.
              No clip-path or mix-blend-mode — both break html2canvas. */}
          <div
            style={{
              position: 'absolute',
              top: -110,
              left: -150,
              width: 500,
              height: 170,
              background: primaryColor,
              transform: 'rotate(15deg)',
              zIndex: 3,
            }}
          />
          <div
            style={{
              position: 'absolute',
              top: -50,
              left: -150,
              width: 440,
              height: 125,
              background: accentColor,
              transform: 'rotate(15deg)',
              zIndex: 4,
            }}
          />

          {/* ── Corner accent — bottom right ─────────────────── */}
          <div
            style={{
              position: 'absolute',
              bottom: -110,
              right: -150,
              width: 500,
              height: 170,
              background: primaryColor,
              transform: 'rotate(15deg)',
              zIndex: 3,
            }}
          />
          <div
            style={{
              position: 'absolute',
              bottom: -50,
              right: -150,
              width: 440,
              height: 125,
              background: accentColor,
              transform: 'rotate(15deg)',
              zIndex: 4,
            }}
          />

          {/* ── Player silhouette (no photo only) ────────────── */}
          {!playerPhoto && (
            <div
              style={{
                position: 'absolute',
                bottom: 300,
                right: 60,
                width: 310,
                height: 520,
                zIndex: 5,
                opacity: 0.11,
                pointerEvents: 'none',
              }}
            >
              {isPitcher ? <PitcherSVG /> : <BatterSVG />}
            </div>
          )}

          {/* ── Player photo ──────────────────────────────────── */}
          {playerPhoto && (
            <div
              ref={playerPhotoContainerRef}
              className="brag-card-player-photo-container"
              style={{
                position: 'absolute',
                left: '50%',
                transform: 'translateX(-50%)',
                top: 280,
                borderRadius: 8,
                overflow: 'hidden',
                border: `14px solid ${accentColor}`,
                boxShadow: '0 0 80px rgba(0,0,0,0.7)',
                zIndex: 6,
              }}
            >
              <img
                src={playerPhoto}
                alt=""
                style={{
                  display: 'block',
                  width: 'auto',
                  height: 'auto',
                  maxWidth: 864,
                  maxHeight: 945,
                  minWidth: 432,
                  transform: `translate(${playerPhotoX - 50}%, ${playerPhotoY - 50}%) scale(${playerPhotoScale / 100})`,
                  transformOrigin: 'center center',
                }}
              />
            </div>
          )}

          {/* ── Milestone label — top ────────────────────────── */}
          <div
            style={{
              position: 'absolute',
              top: 80,
              left: 0,
              width: WIDTH,
              background: accentColor,
              padding: '14px 0',
              zIndex: 10,
            }}
          >
            <div
              style={{
                fontFamily: "'Bebas Neue', 'Arial Narrow', Arial, sans-serif",
                fontSize: 89,
                color: primaryColor,
                letterSpacing: '0.12em',
                textAlign: 'center',
                padding: '0 60px',
              }}
            >
              {milestoneLabel || 'MILESTONE'}
            </div>
          </div>

          {/* ── Bottom gradient fade ──────────────────────────── */}
          <div
            style={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              width: WIDTH,               // explicit px instead of right: 0
              height: 600,
              background:
                'linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.0) 100%)',
              zIndex: 8,
              pointerEvents: 'none',
            }}
          />

          {/* ── Player name + stat line ───────────────────────── */}
          <div
            style={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              width: WIDTH,               // explicit px instead of right: 0
              padding: '0 70px 80px',
              zIndex: 10,
            }}
          >
            <div
              style={{
                width: 110,
                height: 7,
                background: accentColor,
                borderRadius: 4,
                marginBottom: 20,
              }}
            />

            <div
              style={{
                fontFamily: "'Bebas Neue', 'Arial Narrow', Arial, sans-serif",
                fontSize: 130,
                lineHeight: 0.88,
                color: '#ffffff',
                letterSpacing: '0.02em',
                textShadow: '0 4px 40px rgba(0,0,0,0.9)',
                marginBottom: 22,
              }}
            >
              {playerName || 'PLAYER NAME'}
            </div>

            {statLine && (
              <div
                style={{
                  fontFamily:
                    "'Barlow Condensed', 'Barlow', 'Arial Narrow', Arial, sans-serif",
                  fontSize: 56,
                  fontWeight: 700,
                  color: accentColor,
                  letterSpacing: '0.08em',
                  textShadow: '0 2px 16px rgba(0,0,0,0.7)',
                }}
              >
                {statLine}
              </div>
            )}
            {gameContext ? (
              <div style={{
                marginTop: 16,
                fontSize: 36,
                fontFamily: "'Bebas Neue', 'Arial Narrow', Arial, sans-serif",
                color: 'rgba(255,255,255,0.7)',
                letterSpacing: 2,
                textShadow: '0 2px 8px rgba(0,0,0,0.5)',
              }}>
                {gameContext}
              </div>
            ) : null}
          </div>
        </>

      )}

      {/* ── Watermark — free plan only (shared by both templates) ── */}
      {(!subscriptionPlan || subscriptionPlan === 'free') && (
        <div
          style={{
            position: 'absolute',
            bottom: 12,
            right: 12,
            zIndex: 15,
            background: 'rgba(255,255,255,0.92)',
            padding: '6px 12px',
            borderRadius: 8,
            pointerEvents: 'none',
          }}
        >
          <img src="/PMlogoleft.png" alt="Playmaker Media Kit" style={{ height: 80, width: 'auto', display: 'block' }} />
        </div>
      )}

      {/* ── Pexels photo credit (shared by both templates) ────────── */}
      {isPexelsBackground && (
        <div
          style={{
            position: 'absolute',
            bottom: 44,
            left: 70,
            fontFamily: "'Bebas Neue', 'Arial Narrow', Arial, sans-serif",
            fontSize: 30,
            color: 'rgba(255,255,255,0.32)',
            letterSpacing: '0.2em',
            zIndex: 15,
          }}
        >
          PHOTO: PEXELS
        </div>
      )}
    </div>
  );
}
